import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=5fa89298"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports